import React from "react"
import { Link, graphql } from "gatsby"
import get from 'lodash/get'

// import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import "../components/main.css"
import Layout from "../components/layout"

const IndexPage = (props) => {
  const projects = props.data.allContentfulProject.edges;
  return (
    <Layout>
      <div className="projects thumbs-wrap">
        <div className="thumbs-title">Projects</div>
        <div className="angle angle-left no-show">
          <i className="fa fa-angle-left"></i>
        </div>
        <div id="hscroll-projects" className="hscroll thumbs">
          {projects.filter(({ node }) => node.category !== "research").map(({ node }) => {
            return (
              <div className="thumb">
                <Link to={`/projects/${node.slug}`}>
                  <img src={node.thumbnail.file.url} />
                </Link>
                <div className="thumb-title">
                  {node.title}
                </div>
                <div className="thumb-cat">
                  {node.category}
                </div>
              </div>
            )
          })}
        </div>
        <div className="angle angle-right">
          <i className="fa fa-angle-right"></i>
        </div>
      </div>
      <div className="research thumbs-wrap">
        <div className="angle angle-left no-show">
          <i className="fa fa-angle-left"></i>
        </div>
        <div className="thumbs-title">Speculations</div>
        <div id="hscroll-research" className="hscroll thumbs">
          {projects.filter(({ node }) => node.category === "research").map(({ node }) => {
            return (
              <div className="thumb">
                <Link to={`/projects/${node.slug}`}>
                  <img src={node.thumbnail.file.url} />
                </Link>
                <div className="thumb-title">
                  {node.title}
                </div>
                <div className="thumb-cat">
                  {node.category}
                </div>
              </div>
            )
          })}
        </div>
        <div className="angle angle-right">
          <i className="fa fa-angle-right"></i>
        </div>
      </div>
      <div className="footer">
        <div className="office">
          <div className="office-link">
            <a href="<?= site_url() ?>/office">Office</a>
          </div>
          {/* <!--            <div className="locations">-->
              <!--                <span className="location">Los Angeles</span>-->
              <!--                <span className="location">New York</span>-->
              <!--            </div>--> */}
        </div>
        <div style={{ clear: 'both' }}></div>
      </div>
      {/* <div id="news-link">
          <span className="the-link" id="news-click">
              News
              <!--            <i className="fa fa-angle-down"></i>-->
          </span>

          <div id="news-content">
              <div className="container content">
                  <?php while (have_posts()) : the_post(); ?>
                      <div className="news-post">
                          <h4><?php the_title(); ?></h4>
                          <?php the_content(); ?>
                      </div>
                  <?php endwhile; ?>
              </div>
          </div>
      </div> */}

      {/* <h1>Hi people</h1>
      <p>Welcome to your new Gatsby site.</p>
      <p>Now go build something great.</p>
      <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
        <Image />
      </div>
      <Link to="/page-2/">Go to page 2</Link> <br />
      <Link to="/using-typescript/">Go to "Using TypeScript"</Link> */}
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    allContentfulProject(filter: {}) {
      edges {
        node {
          id
          title 
          slug
          location
          category
          thumbnail {
            file {
              url
            }
          }
        }
      }
    }
  }
`